<template>
  <div class="container md:mt-20 mt-20">
    <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
      <div class="lg:col-span-7 md:col-span-6">
        <img src="../assets/images/contact.svg" alt="">
      </div>

      <div class="lg:col-span-5 md:col-span-6 mt-8 md:mt-0">
        <div class="lg:ml-5">
          <div class="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800 p-6">
            <h3 class="mb-6 text-2xl leading-normal font-medium">{{ contactMail.title }}</h3>

            <form  name="myForm" id="myForm">
              <p class="mb-0" id="error-msg"></p>
              <div id="simple-msg"></div>
              <div class="grid lg:grid-cols-12 lg:gap-6">
                <div class="lg:col-span-6 mb-5">
                  <div class="text-left">
                    <label for="name" class="font-semibold">Votre nom:</label>
                    <div class="form-icon relative mt-2">
                      <i class="uil uil-user absolute top-2 left-4"></i>
                      <input name="name" id="name" type="text" class="form-input pl-11" placeholder="Votre nom">
                    </div>
                  </div>
                </div>

                <div class="lg:col-span-6 mb-5">
                  <div class="text-left">
                    <label for="email" class="font-semibold">Votre Email:</label>
                    <div class="form-icon relative mt-2">
                      <i class="uil uil-envelope w-4 h-4 absolute top-2 left-4"></i>
                      <input name="email" id="email" type="email" class="form-input pl-11" placeholder="Email :">
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-1">
                <div class="mb-5">
                  <div class="text-left">
                    <label for="subject" class="font-semibold">Votre Objet:</label>
                    <div class="form-icon relative mt-2">
                      <i class="uil uil-book w-4 h-4 absolute top-2 left-4"></i>
                      <input name="subject" id="subject" class="form-input pl-11" placeholder="Subject :">
                    </div>
                  </div>
                </div>

                <div class="mb-5">
                  <div class="text-left">
                    <label for="comments" class="font-semibold">Votre message:</label>
                    <div class="form-icon relative mt-2">
                      <i class="uil uil-message w-4 h-4 absolute top-2 left-4"></i>
                      <textarea name="comments" id="comments" class="form-input pl-11 h-28"
                        placeholder="Message :"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" id="submit" name="send"
                class="btn bg-bsd-700 hover:bg-bsd--yellow-700 border-bsd--blue-700 text-white rounded-md justify-center flex items-center hover:text-black">Envoyez</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      contactMail: {
        title: 'Prenez contact avec nous !',
        nom: '',
        email: '',
        objet: '',
        commentaire: '',
      },
    }
  }

}
</script>

<style></style>